import { RootState } from 'app/store'

export const selectVehicleList = (state: RootState) => state.vehicleListReducer.vehicleList
export const selectIsLoadingVehicleList = (state: RootState) => state.vehicleListReducer.isLoading
export const selectError = (state: RootState) => state.vehicleListReducer.error
export const selectSortedValue = (state: RootState) => state.vehicleListReducer.sortedValue
